import { Component, Input } from '@angular/core';

import { SmartModalService } from '../../../core/services/smart-modal.service';

@Component({
    selector: 'itpx-simple-info',
    template: `
        <p>{{data.text | translate}}</p>
        <div class="row">
            <div class="pull-right">
                <div class="button-form col-md-12">
                    <button type="button" (click)="onYes()" class="btn {{data.btn}}">
                        {{ data.btnYesText ? data.btnYesText :  'Yes'}}
                    </button>
                    <button type="button" (click)="onNo()" class="btn btn-default">
                        {{ data.btnNoText ? data.btnNoText :  'Cancel'}}
                    </button>
                </div>
            </div>
        </div>
    `
})
export class SimpleInfoComponent {

    @Input()
    private data: any;

    constructor(private modalService: SmartModalService) { }

    private onYes() {
        this.modalService.sendResult(true);
    }

    private onNo() {
        this.modalService.sendResult(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/simple-info.component.ts